import type { FeatureModule } from '@/shell/registry/types'

export default {
  code: 'procurement',
  title: '采购',
  routes: [
    { path: '/procurement', name: 'proc', component: () => import('./ProcView.vue'), meta: { tab: 'apps' } },
  ],
} satisfies FeatureModule
